<section class="manual-punch-dialog">
  <div class="manual-punch-dialog__header">
    <span class="manual-punch-dialog__icon"><mat-icon>add_alarm</mat-icon></span>
    <div>
      <span>{{ 'missingPunchesCatalog.manualPunch.eyebrow' | translate }}</span>
      <h2>{{ 'missingPunchesCatalog.manualPunch.title' | translate }}</h2>
      <p>{{ 'missingPunchesCatalog.manualPunch.description' | translate }}</p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [disabled]="isSaving" [attr.aria-label]="'common.close' | translate"><mat-icon>close</mat-icon></button>
  </div>

  <div class="manual-punch-dialog__body">
    <div class="manual-punch-context">
      <span class="manual-punch-context__avatar">{{ data.employeeName.charAt(0) }}</span>
      <div><small>{{ 'missingPunchesCatalog.table.employee' | translate }}</small><strong>{{ data.employeeName }}</strong><span>{{ data.employeeNumber }}</span></div>
      <div><small>{{ 'missingPunchesCatalog.table.date' | translate }}</small><strong>{{ formattedWorkDate }}</strong><span>{{ data.result.timezone }}</span></div>
      <div class="manual-punch-context__type"><small>{{ 'missingPunchesCatalog.manualPunch.punchType' | translate }}</small><strong><mat-icon>warning_amber</mat-icon>{{ slotLabel }}</strong></div>
    </div>

    <div class="manual-punch-neighbors">
      <div><small>{{ 'missingPunchesCatalog.manualPunch.previousPunch' | translate }}</small><strong>{{ formatPunch(previousPunch) }}</strong></div>
      <mat-icon>arrow_forward</mat-icon>
      <div><small>{{ 'missingPunchesCatalog.manualPunch.newPunch' | translate }}</small><strong>{{ eventTime || '—' }}</strong></div>
      <mat-icon>arrow_forward</mat-icon>
      <div><small>{{ 'missingPunchesCatalog.manualPunch.nextPunch' | translate }}</small><strong>{{ formatPunch(nextPunch) }}</strong></div>
    </div>

    <div class="manual-punch-fields">
      <app-date-time-picker-field [label]="'missingPunchesCatalog.manualPunch.date' | translate"
                                  [value]="eventDate"
                                  mode="date"
                                  [disabled]="isSaving"
                                  [required]="true"
                                  (valueChange)="eventDate = $event">
      </app-date-time-picker-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'missingPunchesCatalog.manualPunch.time' | translate }}</mat-label>
        <mat-icon matPrefix>schedule</mat-icon>
        <input matInput type="time" step="60" [(ngModel)]="eventTime" [disabled]="isSaving" required>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ 'missingPunchesCatalog.manualPunch.reason' | translate }}</mat-label>
      <textarea matInput rows="3" [(ngModel)]="reason" [disabled]="isSaving" maxlength="500" required></textarea>
      <mat-hint>{{ 'missingPunchesCatalog.manualPunch.reasonHint' | translate }}</mat-hint>
    </mat-form-field>

    <div class="manual-punch-warning"><mat-icon>info</mat-icon><span>{{ 'missingPunchesCatalog.manualPunch.auditNotice' | translate }}</span></div>
  </div>

  <div class="manual-punch-dialog__actions">
    <button mat-stroked-button type="button" (click)="close()" [disabled]="isSaving">{{ 'common.cancel' | translate }}</button>
    <button mat-flat-button class="manual-punch-save" type="button" (click)="save()" [disabled]="isSaving">
      @if (isSaving) { <span class="manual-punch-spinner"></span> }
      @else { <mat-icon>add_task</mat-icon> }
      {{ (isSaving ? 'missingPunchesCatalog.manualPunch.saving' : 'missingPunchesCatalog.manualPunch.save') | translate }}
    </button>
  </div>
</section>
